import React, { useEffect, useState } from 'react';

const Gallery = () => {
  const [images, setImages] = useState([]);

  useEffect(() => {
    const fetchImages = async () => {
      try {
        const res = await fetch('https://cms.maitretech.com/seedlingschoolbhopal/items/gallery?fields=*.*.*');
        const data = await res.json();
        const fetchedImages = data?.data?.map(item => {
          const url = item?.uploadphoto?.data?.full_url;
          return url ? url.replace('http://', 'https://') : null;
        }).filter(Boolean); // remove nulls
        setImages(fetchedImages);
      } catch (error) {
        console.error('Failed to fetch images:', error);
      }
    };

    fetchImages();
  }, []);

  return (
    <div className="container-fluid">
      {/* Group images into rows of 4 */}
      {images.length > 0 ? (
        [...Array(Math.ceil(images.length / 4))].map((_, rowIndex) => (
          <div className="first" key={rowIndex}>
            {images.slice(rowIndex * 4, rowIndex * 4 + 4).map((img, i) => (
              <div className="one" key={i}>
                <img src={img} alt={`gallery-${rowIndex * 4 + i + 1}`} />
              </div>
            ))}
          </div>
        ))
      ) : (
        <p>Loading images...</p>
      )}
    </div>
  );
};

export default Gallery;
